module.exports = __webpack_public_path__ + "static/BentonSansExtraComp-Medium-e328d13213eb775a8a5ca017c3fb6a0f.woff";